import React from "react";

const Category = ({ category }) => {
  // return (
  //   <select
  //     key={category.id}
  //     name=""
  //     id={category.id}
  //     className="font-pop font-normal text-sm text-darkGreen opacity-60 bg-transparent outline-none"
  //   >
  //     <option value="">{category.name}</option>
  //     <option value="">Laptop</option>
  //   </select>
  // );
  return (
    <p className="cursor-pointer bg-transparent font-pop text-sm font-normal text-darkGreen opacity-60 outline-none">
      {category.name}
    </p>
  );
};

export default Category;
